import axios from "axios";
import Swal from "sweetalert2";

export const getSections = async (type ,search) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/sections",    
        {params:{
          type:type,
          search
        }
          ,
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
  export const showSections = async (id ,lang) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        `/v1/admin/sections/${id}`,    
        {
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-language":lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
  export const storeSections = async (postData ) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/sections", postData,   
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-language":lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

    export const updateSections = async (postData,id ) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        `/v1/admin/sections/${id}`, postData,   
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-language":lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };


    export const deleteSections = async (id,lang) => {
    const brear = localStorage.getItem("token");
    const result = await Swal.fire({
      title: "هل انت متأكد ؟",
      text: "سيتم الحذف",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Okay",
    });
    if (result.isConfirmed) {
      try {
        const { data } = await axios.delete(`/v1/admin/sections/${id}`, {headers:{
 Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        }
         
        });
        if (data.success === true) {
          Swal.fire("Deleted!", `${data.message}`, "success");
        } else {
          Swal.fire("Not deleted", `${data.message}`, "info");
        }
        return data;
      } catch (error) {
        throw error;
      }
    }
  };